'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FacebookSDK = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _universalConfig = require('universal-config');

var _universalConfig2 = _interopRequireDefault(_universalConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fbScriptRendered = false;

var FB_SDK_JS = '(function(d, s, id){\n    var js, fjs = d.getElementsByTagName(s)[0];\n    if (d.getElementById(id)) {return;}\n    js = d.createElement(s); js.id = id;\n    js.src = "//connect.facebook.net/en_US/sdk.js";\n    fjs.parentNode.insertBefore(js, fjs);\n}(document, \'script\', \'facebook-jssdk\'));';

var FacebookSDK = exports.FacebookSDK = function (_React$Component) {
  (0, _inherits3.default)(FacebookSDK, _React$Component);

  function FacebookSDK() {
    (0, _classCallCheck3.default)(this, FacebookSDK);
    return (0, _possibleConstructorReturn3.default)(this, (FacebookSDK.__proto__ || (0, _getPrototypeOf2.default)(FacebookSDK)).apply(this, arguments));
  }

  (0, _createClass3.default)(FacebookSDK, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (fbScriptRendered && !__TEST__) {
        return;
      }
      fbScriptRendered = true;

      var config = (0, _universalConfig2.default)();

      var sdkInitJs = 'window.fbAsyncInit = function() {\n      FB.init({\n        appId: ' + (config && config.fb && config.fb.appId) + ',\n        xfbml : true,\n        version : \'v2.10\'\n      });\n\n      FB.getLoginStatus(function (response) {\n        window._fbAuthResponse = response;\n\n        var event = document.createEvent(\'Event\');\n        event.initEvent(\'facebookReady\', true, true);\n        document.body.dispatchEvent(event);\n      });\n    };';

      var script = document.createElement('script');
      script.textContent = FB_SDK_JS + sdkInitJs;
      script.id = 'fb-js-root';
      document.body.appendChild(script);
    }
  }, {
    key: 'render',
    value: function render() {
      return false;
    }
  }]);
  return FacebookSDK;
}(_react2.default.Component);